module.exports = __webpack_public_path__ + "static/media/header1.64f388f7.jpg";